import { render, staticRenderFns } from "./ImgSetting.vue?vue&type=template&id=ad99e7ec&scoped=true"
import script from "./ImgSetting.vue?vue&type=script&lang=js"
export * from "./ImgSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad99e7ec",
  null
  
)

export default component.exports